/**
 * WordPress dependencies
 */
import { Dashicon } from '@safe-wordpress/components';
import { useSelect } from '@safe-wordpress/data';
import { _x } from '@safe-wordpress/i18n';

/**
 * External dependencies
 */
import { store as NAB_DATA } from '@nab/data';

/**
 * Internal dependencies
 */
import './style.scss';
import { useActiveExperiment } from '../../hooks';

export const NoQuotaWarning = (): JSX.Element | null => {
	const quota = useSelect( ( select ) => select( NAB_DATA ).getQuota(), [] );
	const status = useActiveExperiment()?.status;

	if ( ! quota || quota.availableQuota ) {
		return null;
	}

	if ( 'running' !== status ) {
		return null;
	}

	return (
		<div className="nab-heatmap-results-sidebar__no-quota-warning">
			<Dashicon icon="warning" />
			<span>
				{ _x(
					'Event tracking has stopped because there’s no more quota available at the moment.',
					'text',
					'nelio-ab-testing'
				) }
			</span>
		</div>
	);
};
